import React, { useEffect, useState } from 'react';
import '../css/profile.css';
import Navbar from '../landingComponents/Navbar';
import Footer from '../landingComponents/Footer';
import { accessCourse, BaseImgUrl, courseCompletion, profileDetails } from '../Services/Api';
import { Link } from 'react-router-dom';

const InstructorProfile = () => {

  const [profileData, setProfileData] = useState([]);
  const [completionCount, setCompletionCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
     document.title = 'Profile';
    const fetchProfileDetails = async () => {
      try {
        const response = await profileDetails();
        setProfileData(response.data);
        // console.log(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching profile details:', err);
        setLoading(false);
      }
    };

    fetchProfileDetails();
  }, []);
  useEffect(() => {
    const courseComplete = async () => {
      try {
        const response = await courseCompletion();
        setCompletionCount(response.data);
        // console.log(response);
        // setLoading(false);
      } catch (err) {
        console.error('Error fetching profile details:', err);
        // setLoading(false);
      }
    };

    courseComplete();
  }, []);

  //  if (loading) return <div>Loading...</div>;
  //   if (error) return <div>Error loading profile</div>;
  //   if (!profileData) return <div>No profile data found</div>;

  //   const handleAccessCourse = async () => {
  //   try {
  //     const response = await accessCourse(id); // <-- this should call axios/fetch to Laravel
  //     const data = response;
  //     // console.log(data.token);


  //     if (data.status === "success") {
  //       // Create hidden form
  //       const form = document.createElement("form");
  //       form.method = "POST";
  //       form.action = data.redirect_url;

  //       // Add hidden fields
  //       ["encrypname", "token", "course_id"].forEach((field) => {
  //         const input = document.createElement("input");
  //         input.type = "hidden";
  //         input.name = field;
  //         input.value = data[field];
  //         form.appendChild(input);
  //       });

  //       document.body.appendChild(form);
  //       form.submit(); // auto-submit to Moodle
  //     } else {
  //       alert("Access denied: " + data.message);
  //     }
  //   } catch (err) {
  //     console.error("Error accessing course:", err);
  //     alert("Something went wrong while accessing the course.");
  //   }
  // };

  const handleAccessCourse = () => {

  }
  return (



    <>
      <Navbar />
      {profileData && profileData.user && (
        <>
          <div className="eCourse-profile-header">
            <div className="eCourse-profile-header-content">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQTfr-VGQmG3nOKJGZ9rviTPOJ4RZb1L3qUGQ&s"
                alt="Prof. Sarah Johnson"
                className="eCourse-profile-img"
              />
              <h1 className="eCourse-profile-name">{profileData.user.firstname}</h1>
              <div className="eCourse-profile-title">{profileData.user.username}</div>
              {/* <div className="eCourse-profile-title">{profileData.user.company_name.toUpperCase()}</div>
              <div className="eCourse-profile-location">
                <i className="fas fa-map-marker-alt"></i>
                <span>{profileData.user.address}</span>
              </div> */}
              {/* <div className="eCourse-social-links">
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-linkedin-in"></i></a>
            <a href="#"><i className="fab fa-github"></i></a>
            <a href="#"><i className="fab fa-youtube"></i></a>
          </div> */}
            </div>
          </div>
          <div className="eCourse-profile-container">


            <div className="eCourse-stats-container">
              <div className="eCourse-stat-item">
                <div className="eCourse-stat-icon">
                  <i className="fas fa-graduation-cap"></i>
                </div>
                <h3>{profileData.course_details.length}</h3>
                <p>Enrolled Course Count</p>
              </div>
              <div className="eCourse-stat-item">
                <div className="eCourse-stat-icon">
                  <i className="fas fa-trophy"></i>
                </div>
                <h3>{completionCount.length}</h3>
                <p>Completed Course Count</p>
              </div>
              {/* <div className="eCourse-stat-item">
                <div className="eCourse-stat-icon">
                  <i className="fas fa-star"></i>
                </div>
                <h3>4.9</h3>
                <p>Completion Percentage</p>
              </div> */}
              {/* <div className="eCourse-stat-item">
                <div className="eCourse-stat-icon">
                  <i className="fas fa-medal"></i>
                </div>
                <h3>9</h3>
                <p>Awards</p>
              </div> */}
            </div>

            <div className="eCourse-content-container">
              <div className="eCourse-main-content">
                <ProfileAbout user={profileData.user} />
                {/* <p>{profileData.user}</p>  */}
              </div>
              <div className="eCourse-sidebar">
                <FeaturedCourses course={profileData.course_details} />
                {/* <Credentials />
          <Expertise />
          <ContactInfo /> */}
              </div>
            </div>
          </div>
        </>
      )}
      <Footer />
    </>
  );
};

const ProfileAbout = ({ user }) => {
  if (!user) {
    return <div>Loading user information...</div>;
  }
  return (
    <div className="profile-section">
      <h2 className="profile-section-title"><i className="fas fa-user"></i> User Information</h2>
      <div className="profile-details">
        <div className="detail-row">
          <span className="detail-label">Name:</span>
          <span className="detail-value">{user.firstname}</span>
          {/* <span className="detail-value">{user.name}</span> */}
        </div>
        <div className="detail-row">
          <span className="detail-label">OCP ID:</span>
          <span className="detail-value">{user.ocp_cer_id}</span>
          {/* <span className="detail-value">{user.name}</span> */}
        </div>
        <div className="detail-row">
          <span className="detail-label">Username:</span>
          <span className="detail-value">{user.username}</span>
          {/* <span className="detail-value">{user.username}</span> */}
        </div>
        <div className="detail-row">
          <span className="detail-label">Email:</span>
          <span className="detail-value">{user.email}</span>
          {/* <span className="detail-value">{user.email}</span> */}
        </div>
        <div className="detail-row">
          <span className="detail-label">phone:</span>
          <span className="detail-value">{user.phone}</span>
          {/* <span className="detail-value">{user.email}</span> */}
        </div>
        {/* <div className="detail-row">
          <span className="detail-label">Password:</span>
          <span className="detail-value">••••••••</span>
        </div> */}
        {/* <div className="detail-row">
          <span className="detail-label">Account Created On:</span>
          <span className="detail-value">{user.created_at}</span> */}
        {/* <span className="detail-value">{user.joinDate}</span> */}
        {/* </div> */}

        {/* <div className="detail-row">
          <span className="detail-label">Last Login:</span>
          <span className="detail-value">3</span> */}
        {/* <span className="detail-value">{user.lastLogin}</span> */}
        {/* </div> */}
      </div>
    </div>
  )
};

// Example usage:
{/* <ProfileAbout user={{
  name: "John Doe",
  username: "johndoe123",
  email: "john.doe@example.com",
  joinDate: "January 15, 2022",
  lastLogin: "2 hours ago"
}} /> */}

const FeaturedCourses = ({ course }) => (
  <div className="eCourse-section">
    <h2 className="eCourse-section-title">
      <i className="fas fa-book-open"></i> Featured Courses
    </h2>

    {
      course && course.length > 0 ? (
        course.map((course, index) => (
          <div className="eCourse-card" key={index}>
            <img
              src={`${BaseImgUrl}/${course.new_category_img_url}`}
              alt={course.category_name}
              className="eCourse-card-img"
            />

            <div className="eCourse-card-info">
              <h4>{course.category_name}</h4>
              <p>{course.category_desc}</p>
              <div className="eCourse-price">₹{course.course_price}</div>
              {/* <button
                className="eCourse-btn eCourse-btn-outline"
              // onClick={handleAccessCourse}
              > */}
              <Link className="eCourse-btn eCourse-btn-outline" to={`/category/${course.hashed_id}`}>
                View Course
              </Link>
              {/* </button> */}
            </div>
          </div>
        ))
      ) : (
        <div className="eCourse-card" >
          <div className="eCourse-card-info">
            <h4 style={{ textAlign: "center" }}>No Course Enrolled</h4>
            {/* <p>{course.category_desc}</p> */}
            {/* <div className="eCourse-price">₹{course.course_price}</div> */}
            <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
              <Link to='/' className="eCourse-btn eCourse-btn-outline">Explore Course</Link>
            </div>

          </div>
        </div>
      )

    }
  </div>
);


//   const renderStars = () => {
//     const stars = [];
//     const fullStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 !== 0;

//     for (let i = 0; i < fullStars; i++) {
//       stars.push(<i key={`full-${i}`} className="fas fa-star"></i>);
//     }

//     if (hasHalfStar) {
//       stars.push(<i key="half" className="fas fa-star-half-alt"></i>);
//     }

//     const remaining = 5 - stars.length;
//     for (let i = 0; i < remaining; i++) {
//       stars.push(<i key={`empty-${i}`} className="far fa-star"></i>);
//     }

//     return stars;
//   };

//   return (
//     <div className="eCourse-card">
//       <img src={image} alt={title} className="eCourse-card-img" />
//       <div className="eCourse-card-info">
//         <h4>{title}</h4>
//         <div className="eCourse-card-meta">
//           <span><i className="far fa-clock"></i> {duration}</span>
//           <span><i className="fas fa-layer-group"></i> {level}</span>
//           {certificate && <span><i className="fas fa-certificate"></i> Certificate</span>}
//         </div>
//         <div className="eCourse-stars">
//           {renderStars()}
//           <span>({reviews} reviews)</span>
//         </div>
//         <p>{description}</p>
//         <div className="eCourse-price">{price}</div>
//         <a href="#" className="eCourse-btn eCourse-btn-outline">View Course</a>
//       </div>
//     </div>
//   );
// };

const Credentials = () => (
  <div className="eCourse-section">
    <h2 className="eCourse-section-title"><i className="fas fa-certificate"></i> Credentials</h2>

    <CredentialItem
      icon="fas fa-graduation-cap"
      title="Ph.D. Educational Technology"
      issuer="Stanford University · 2015"
    />

    <CredentialItem
      icon="fas fa-award"
      title="Certified Online Instructor"
      issuer="Online Learning Consortium · 2018"
    />

    <CredentialItem
      icon="fas fa-chalkboard-teacher"
      title="Learning Experience Designer"
      issuer="ATD Certification · 2020"
    />
  </div>
);

const CredentialItem = ({ icon, title, issuer }) => (
  <div className="eCourse-credential">
    <div className="eCourse-credential-icon">
      <i className={icon}></i>
    </div>
    <div className="eCourse-credential-info">
      <h4>{title}</h4>
      <p>{issuer}</p>
    </div>
  </div>
);

const Expertise = () => (
  <div className="eCourse-section">
    <h2 className="eCourse-section-title"><i className="fas fa-tools"></i> Expertise</h2>
    <div className="eCourse-skills">
      <div className="eCourse-skill">Instructional Design</div>
      <div className="eCourse-skill">eLearning Development</div>
      <div className="eCourse-skill">Curriculum Design</div>
      <div className="eCourse-skill">Learning Analytics</div>
      <div className="eCourse-skill">Gamification</div>
      <div className="eCourse-skill">EdTech</div>
      <div className="eCourse-skill">Assessment Design</div>
      <div className="eCourse-skill">Adult Learning</div>
    </div>
  </div>
);

const ContactInfo = () => (
  <div className="eCourse-section">
    <h2 className="eCourse-section-title"><i className="fas fa-envelope"></i> Contact</h2>
    <div className="eCourse-contact-info">
      <div className="eCourse-contact-item">
        <i className="fas fa-globe"></i>
        <span>professorsarahjohnson.com</span>
      </div>
      <div className="eCourse-contact-item">
        <i className="fas fa-envelope"></i>
        <span>sarah@stanford.edu</span>
      </div>
      <div className="eCourse-contact-item">
        <i className="fas fa-calendar-alt"></i>
        <span>Book Consultation</span>
      </div>
    </div>
    <a href="#" className="eCourse-btn"><i className="fas fa-paper-plane"></i> Send Message</a>
  </div>
);

export default InstructorProfile;